import * as aiToolkitApi from '../api';
import {
  IAnalyzeFeedRequestData,
  IAnalyzeFeedResponseData,
  ICreateGptJobRequestData,
  ICreateGptJobResponseData,
  ICreateGptJobTitlePreviewRequestData,
  ICreateGptJobTitlePreviewResponseData,
  IEditMyGptJobRequestData,
  IGetGptJobDetailsResponseData,
  IGetMyGptJobsResponseData,
} from '../types';

export const getMyGptJobs = async (): Promise<IGetMyGptJobsResponseData> =>
  aiToolkitApi.getMyGptJobs();

export const editGptJob = async (
  requestData: IEditMyGptJobRequestData
): Promise<void> => aiToolkitApi.editGptJob(requestData);

export const getGptJobDetails = async (
  gptJobId: string
): Promise<IGetGptJobDetailsResponseData> =>
  aiToolkitApi.getGptJobDetails(gptJobId);

export const analyzeFeed = async (
  requestData: IAnalyzeFeedRequestData
): Promise<IAnalyzeFeedResponseData> => aiToolkitApi.analyzeFeed(requestData);

export const createGptJob = async (
  requestData: ICreateGptJobRequestData
): Promise<ICreateGptJobResponseData> => aiToolkitApi.createGptJob(requestData);

export const createGptJobTitlePreview = async (
  requestData: ICreateGptJobTitlePreviewRequestData
): Promise<ICreateGptJobTitlePreviewResponseData> =>
  aiToolkitApi.createGptJobTitlePreview(requestData);
